import { ReactNode } from "react";
import cn from "classnames";
import s from "./LogoList.module.scss";
import bs from "../../styles/block.spacing.module.scss";

import List from "./components/List";
import Logo from "./components/Logo";
import { InnerSpacingVariant } from "../../lib/storyblok/types/shared";
import BlockIntro from "../Common/BlockIntro";
import type { RichTextContent } from "../../lib/storyblok/types/fieldtypes/richText";

type Props = {
  title: string;
  description?: RichTextContent;
  spacing: InnerSpacingVariant;
  children: ReactNode;
  headingSize?: "xxs" | "xs" | "small" | "medium" | "large";
  heroArea?: boolean;
};

const subComponents = { List, Logo };
type Subcomponents = typeof subComponents;

const LogoList: CWS<Props, Subcomponents> = ({
  title,
  description,
  spacing = "both",
  headingSize = "medium",
  children,
  heroArea = false,
}) => {
  return (
    <section className={cn(s.logoList, bs[spacing], s[headingSize])}>
      <BlockIntro
        alignment="alignCenter"
        title={title}
        description={description}
        width={"contained"}
        titleSize={headingSize === "medium" ? "default" : headingSize}
        descriptionSize={headingSize === "medium" ? "default" : headingSize}
        titleStyle={heroArea ? "faded" : "default"}
        descriptionStyle={heroArea ? "faded" : "default"}
        gap="small"
      />

      {children}
    </section>
  );
};

LogoList.List = List;
LogoList.Logo = Logo;

export default LogoList;
